import React from 'react'
import styled from 'styled-components'

const StyledCard = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.default};
  overflow: hidden;
`

export interface SimpleCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

export const SimpleCard: React.FC<SimpleCardProps> = ({
  children,
  ...props
}) => {
  return <StyledCard {...props}>{children}</StyledCard>
}

// Export with Card name for backward compatibility
export const Card = SimpleCard
